// extracted by mini-css-extract-plugin
export default {"paginationContainer":"FeedPagination_paginationContainer__tSh2D","displayingDescContainer":"FeedPagination_displayingDescContainer__IQaYl"};